import { Suspense } from "react";

import { MapPanel } from "~/modules/map/components/MapPanel";
import { ObservationCardFragment } from "~/modules/mapEditor/components/ObservationCard/fragments.generated";

import { MapEditorObservationMediaPointPanelEditable } from "./MapEditorObservationMediaPointPanelEditable";
import { MapEditorObservationMediaPointPanelSkeleton } from "./MapEditorObservationMediaPointPanelSkeleton";

export interface MapEditorObservationMediaPointPanelProps {
    backHref: string;
    createHrefToObservation: (element: ObservationCardFragment) => string;
    mapEditorFeatureId: string;
    title: string;
}

export function MapEditorObservationMediaPointPanel({
    backHref,
    createHrefToObservation,
    mapEditorFeatureId,
    title,
}: MapEditorObservationMediaPointPanelProps) {
    return (
        <MapPanel>
            <Suspense key={mapEditorFeatureId} fallback={<MapEditorObservationMediaPointPanelSkeleton />}>
                <MapEditorObservationMediaPointPanelEditable
                    backHref={backHref}
                    createHrefToObservation={createHrefToObservation}
                    mapEditorFeatureId={mapEditorFeatureId}
                    title={title}
                />
            </Suspense>
        </MapPanel>
    );
}
